var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 150,
    viewBox: "0 0 146 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline:interface-favorite-give-heart-reward-social-rating-media-heart-hand",
    filter: "url(#filter0_d_111_401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.21387 88.6428H26.071C32.9856 88.6428 39.6169 91.3896 44.5063 96.2789C49.3956 101.168 52.1424 107.8 52.1424 114.714M20.8567 114.714H72.9996C78.5312 114.714 83.8363 116.912 87.7478 120.823C91.6593 124.735 93.8567 130.04 93.8567 135.571C93.8567 136.954 93.3074 138.281 92.3295 139.258C91.3516 140.236 90.0253 140.786 88.6424 140.786H5.21387M91.2496 88.6428L49.5353 50.0571C26.801 27.2185 59.9639 -16.9986 91.2496 18.7714C122.535 -16.8944 156.011 27.3228 132.964 50.0571L91.2496 88.6428Z",
    stroke: "#FFF1CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_111_401",
    x: -4,
    y: 0,
    width: 154,
    height: 154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_401"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_401",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.e12fb998a19b1ed5daa45e072e3929c6.svg";
export { ForwardRef as ReactComponent };